import { NEW_EDIT_ICON } from 'constants/commonIcons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerContacts } from 'selectors/customerContacts';
import EditCustomerContactsModal from './EditCustomerContactsModal';

const CustomerContactsCard: React.FC = () => {
  // const dispatch = useDispatch();

  const customerContacts = useSelector(getCustomerContacts);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const toggleEditModal = (): void => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  return (
    <>
      <div className="w-112 h-80 pt-6 px-6 pb-8 flex flex-col gap-4 text-body bg-white border border-litlingo-gray-2 rounded">
        <div className="flex flex-row justify-between">
          <span className="text-heading-2">Contacts</span>
          <button
            type="button"
            onClick={toggleEditModal}
            className="w-5 underline focus:outline-none"
          >
            {NEW_EDIT_ICON('text-litlingo-primary-120')}
          </button>
        </div>

        <div className="pl-4 flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <p>
              <b>Main Point of Contact</b>
            </p>
            <p>{customerContacts?.main_contact_name || 'Not defined'}</p>
            <p>{customerContacts?.main_contact_email || 'Not defined'}</p>
          </div>

          <div className="flex flex-col gap-1">
            <p>
              <b>IT Primary Contact</b>
            </p>
            <p>{customerContacts?.it_primary_contact_name || 'Not defined'}</p>
            <p>{customerContacts?.it_primary_contact_email || 'Not defined'}</p>
          </div>

          <div className="flex flex-col gap-1">
            <p>
              <b>IT Secondary Contact</b>
            </p>
            <p>{customerContacts?.it_secondary_contact_name || 'Not defined'}</p>
            <p>{customerContacts?.it_secondary_contact_email || 'Not defined'}</p>
          </div>
        </div>
      </div>
      {isEditModalOpen && (
        <EditCustomerContactsModal
          isModalOpen={isEditModalOpen}
          toggleModalOpen={toggleEditModal}
        />
      )}
    </>
  );
};

export default CustomerContactsCard;
